import styled from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'
import { FILTER_AND_SORT_BUTTON_WIDTH, PILL_HEIGHT } from '../../constants/styling'

export const StyledCTAContainer = styled.div`
    padding: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme) + ' 0'};
    z-index: 20;
    @media (max-width: 767px) {
        position: sticky;
        top: 0;
        display: flex;
        align-items: stretch;
        background-color: ${({ theme }) => theme.color.bgSurface.default};
        flex-direction: row;
        justify-content: space-between;
        width: calc(100% + 80px);
        @media (max-width: 767px) {
            margin-left: -65px;
        }

        > div {
            position: relative;
            &:first-child {
                width: 100%;
            }
        }

        a,
        svg {
            fill: currentColor;
        }
        .atds-icon {
            display: none;
        }
    }
    @media (min-width: 768px) {
        display: flex;
        column-gap: 16px;
        background: ${({ theme }) => theme.color.bgSurface.default};
        align-items: center;
        justify-content: flex-end;
        position: sticky;
        top: 0;
    }
`

export const MobileDisplayContainer = styled.div`
    align-items: center;
    padding-bottom: 2px;
    @media (max-width: 767px) {
        display: flex;
        height: ${PILL_HEIGHT};
        width: ${PILL_HEIGHT};
    }
    @media (min-width: 768px) {
        display: none;
        height: 0;
        width: 0;
    }
`

export const DesktopDisplayContainer = styled.div`
    align-items: center;
    padding-bottom: 2px;
    @media (max-width: 767px) {
        display: none;
        height: 0;
        width: 0;
    }
    @media (min-width: 768px) {
        display: flex;
        height: ${PILL_HEIGHT};
        width: ${FILTER_AND_SORT_BUTTON_WIDTH};
    }
`
